import React from 'react';
import './App.css';
import './index.css';
// Import the Routes component from Router.js
import Routes from './router';

function App() {
  return (
    <div className="App bg-blue-500 min-h-screen">
      <Routes />
    </div>
  );
}

export default App;
